import api from '@/apis/pa/paLayoutTemplateAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('pALayoutTemplate', api);

const state = {
  ...crud.state,
  _config: {
    table: 'pa_layout_template',
    field: {
      key: 'pa_layout_template_id',
    },
  },
  dataLayoutTemplates: [],
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  insertItem(context, item) {
    context.commit('insertItem', item);
  }
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
